module.exports = __webpack_public_path__ + "img/IMG_1043.859666ab.jpeg";